module.exports = __webpack_public_path__ + "static/media/Cyclus.46ce6f80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/endtest/assets/Cyclus.svg
// module id = 582
// module chunks = 0